module.exports = __webpack_public_path__ + "static/media/liberty-small.5b530929.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/liberty-small.jpg
// module id = 2807
// module chunks = 0